// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7a3d2456","453":"ec5f6c87"}[chunkId] + ".chunk.js";
};